import * as z from "zod";
import { hsaAnswer } from "../hsa-answer";

// Terminal step of a handoff survey: the server re-checks and submits to the
// partner, returning where to send the shopper (payment, or the failure URL).
export const finalizeHandoffSurveyInput = z.object({
  sessionToken: z.string().uuid(),
  answers: z.record(z.string(), hsaAnswer),
});

export const finalizeHandoffSurveyOutput = z.object({
  redirectUrl: z.string(),
});
